<script setup>
import { computed } from 'vue'
import { textColor } from '@/lib/utils'

import { DEFAULT_EXPENSE_ITEM_COLOR, DEFAULT_EXPENSE_ITEM_ICON } from '@/stores/accounting.store'

const props = defineProps({
  item: {
    type: Object,
    default: null,
  },
})

const color = computed(() => props.item?.color ?? DEFAULT_EXPENSE_ITEM_COLOR)
</script>

<template>
  <q-avatar
    size="md"
    :icon="props.item?.icon ?? DEFAULT_EXPENSE_ITEM_ICON"
    :style="{ 'background-color': color, color: textColor(color) }"
  />
</template>
